import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import { format } from 'date-fns';
import CalendarEngageV2 from '../icons/calendar-engage-v2.svg';
import styles from './styles.module.scss';
import { TextM } from '../../../../infra/dls/components/typography/typography';
export var DatepickerTrigger = forwardRef(function (_a, ref) {
    var _b;
    var placeholder = _a.placeholder, value = _a.value, isOpen = _a.isOpen, disabled = _a.disabled, hasError = _a.hasError, onClick = _a.onClick, dateFormat = _a.dateFormat;
    var handleClick = function (e) {
        e.stopPropagation();
        e.preventDefault();
        onClick();
    };
    return (_jsxs("button", { ref: ref, type: "button", onClick: handleClick, className: classNames(styles['trigger-button'], (_b = {},
            _b[styles['is-focused']] = isOpen,
            _b[styles['is-disabled']] = disabled,
            _b[styles['is-error']] = hasError,
            _b[styles['is-selected']] = !!value,
            _b)), children: [_jsx(CalendarEngageV2, {}), _jsx(TextM, { children: value ? format(value, dateFormat) : placeholder })] }));
});
DatepickerTrigger.displayName = 'DatepickerTrigger';
